export function SkeletonTiles({ count = 6 }) {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="h-24 rounded-2xl bg-surface-2 animate-pulse" />
      ))}
    </div>
  );
}

export function SkeletonRows({ rows = 5 }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="h-16 rounded-2xl bg-surface-2 animate-pulse" />
      ))}
    </div>
  );
}

export function SkeletonLine({ className = '' }) {
  return <div className={`h-3 rounded bg-surface-2 animate-pulse ${className}`} />;
}
